import _ from "lodash";
import React, { useEffect, useState, useMemo } from "react";
import { useHistory } from "react-router";
import { useParams } from "react-router-dom";

import DynamicWizard from "components/crud/DynamicWizard";
import ALoader from "views/pages/manage/common/a-loader";

import { EMPTY_FORM_STATE } from "./helper";
import SelectYearStep from "./SelectYearStep";
import WizardSummaryHoc from "./WizardSummaryHoc";
import SelectCourseIdStep from "./SelectCourseIdStep";
import SelectMaterialIdStep from "./SelectMaterialIdStep";
import { getMappingById, structureDataIntoForm } from "./utilsFunctions";

const CourseMaterialMapping = () => {
  const { id } = useParams();
  const history = useHistory();

  const [userInfo, setUserInfo] = useState(EMPTY_FORM_STATE);
  const [isFetchingData, setIsFetching] = useState(true);

  useEffect(() => {
    if (id) fetchMappingDetails();
    else setIsFetching(false);
  }, []);

  const fetchMappingDetails = async () => {
    const response = await getMappingById(id);

    if (_.isEmpty(response)) history.push("/admin/pageNotFound");
    else {
      const prefillUserInfo = structureDataIntoForm(response);
      setUserInfo(prefillUserInfo);
    }

    setIsFetching(false);
  };

  const mappingFormWizard = useMemo(
    () => ({
      heading: (
        <h1 className="mb-0">{`${
          id ? "Edit" : "Create New"
        } Course-Material Mapping`}</h1>
      ),
      initialValues: userInfo,
      searchWizard: {
        isShow: false,
      },
      isStepperNavigationAllowed: false,
      backIconClickHandler: () => history.goBack(),
      steps: [
        {
          id: "selectCourseId",
          label: "Select Course ID",
          component: WizardSummaryHoc(SelectCourseIdStep),
        },
        {
          id: "selectYear",
          label: "Select Year",
          component: WizardSummaryHoc(SelectYearStep),
        },
        {
          id: "selectMaterials",
          label: "Select Material ID",
          component: WizardSummaryHoc(SelectMaterialIdStep),
        },
      ],
    }),
    [userInfo]
  );

  if (isFetchingData)
    return (
      <div
        className="text-center position-absolute"
        style={{ width: "100vw", height: "70vh" }}
      >
        <ALoader />
      </div>
    );

  return (
    <div>
      <DynamicWizard
        config={mappingFormWizard}
        onFinished={() => {}}
        recordId={90}
      />
    </div>
  );
};

export default CourseMaterialMapping;
